import React, { ReactElement } from 'react';
import { TouchableOpacity, ViewStyle } from 'react-native';

import KitIcon from '../KitIcon';

export default function Icon({
  containerStyle,
  onPress,
}: {
  containerStyle?: ViewStyle | ViewStyle[];
  onPress?: () => void;
}): ReactElement {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={containerStyle}
      testID='icon_container'
    >
      <KitIcon name='arrow-down' size={20} />
    </TouchableOpacity>
  );
}
